export const CREATE = 'TRAINING_PLAN_CREATE';
export const CREATE_SUCCEEDED = 'TRAINING_PLAN_CREATE_SUCCEEDED';
export const CREATE_FAILED = 'TRAINING_PLAN_CREATE_FAILED';
